import { useTranslation } from "react-i18next";
import { Steps } from "@/core/shared/v2/ui/steps";
import { useFlowSteps } from "../../hooks/use-flow-steps";

// Progress indicator shown at the top of every flow page (REV-21). Resolves the current step from
// the route itself, so pages just drop it in without passing props.
export const FlowSteps = () => {
  const { t } = useTranslation();
  const { stepLabels, currentStepIndex } = useFlowSteps();

  if (currentStepIndex < 0) return null;

  return (
    <Steps
      className="mb-8 lg:mb-10"
      steps={stepLabels}
      currentStep={currentStepIndex}
      progressLabel={t("GROUP_ACTIONS_ORDERING.STEPS.PROGRESS", {
        current: currentStepIndex + 1,
        total: stepLabels.length,
      })}
    />
  );
};
